import { AccountHistory } from '../../type';

export const getHisMvtTableNameFromId = (hisMvtId: AccountHistory['HIS_MVT.ID']) => hisMvtId.substr(0, hisMvtId.lastIndexOf('_'));

export const getHisMvtTableNameFromHistoryLine = (historyLine: AccountHistory) => getHisMvtTableNameFromId(historyLine['HIS_MVT.ID']);

export const isHisMvtTableCountedFromId = (hisMvtId: AccountHistory['HIS_MVT.ID']) => getHisMvtTableNameFromId(hisMvtId) === 'HIS_MVT';

export const isHisMvtTableCountedFromHistoryLine = (historyLine: AccountHistory | undefined | null) => (historyLine ? isHisMvtTableCountedFromId(historyLine['HIS_MVT.ID']) : false);
